var React = require('react');

function CategoryDigital (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M14.3,12H1.7C0.7,12,0,11.3,0,10.4V2.5c0-0.9,0.7-1.7,1.7-1.7h12.7c0.9,0,1.7,0.7,1.7,1.7v7.9C16,11.3,15.3,12,14.3,12z\n\t M1.7,10.3h12.5V2.5H1.7V10.3z M14.3,2.5L14.3,2.5L14.3,2.5z","key":0}),React.createElement("path",{"d":"M12,15.2H4c-0.5,0-0.9-0.4-0.9-0.9s0.4-0.9,0.9-0.9H12c0.5,0,0.9,0.4,0.9,0.9S12.4,15.2,12,15.2z","key":1}),React.createElement("path",{"d":"M5.6,15.2c-0.5,0-0.9-0.4-0.9-0.9v-3.2c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v3.2C6.5,14.8,6.1,15.2,5.6,15.2z","key":2}),React.createElement("path",{"d":"M10.4,15.2c-0.5,0-0.9-0.4-0.9-0.9v-3.2c0-0.5,0.4-0.9,0.9-0.9s0.9,0.4,0.9,0.9v3.2C11.2,14.8,10.9,15.2,10.4,15.2z","key":3})]);
}

CategoryDigital.defaultProps = {"version":"1.1","id":"digital","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = CategoryDigital;

CategoryDigital.default = CategoryDigital;
